// src/main.jsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom'

import { initThemeFromCache } from './utils/theme'
import { initFontFromCache } from './utils/fontSize'
import { AppProvider } from './context/AppContext';

// 2. run it immediately (before CSS & React mount)
initThemeFromCache()
initFontFromCache()


import './assets/styles/index.css';

import Home from './pages/Home'
import Dashboard from './pages/Dashboard'
import ProfilePage from './pages/Profile';
import Login from './pages/auth/Login'
import Register from './pages/auth/Register'
import Unsubscribe from './pages/auth/Unsubscribe'
import Subscribe from './pages/auth/Subscribe'
import RecoverPassword  from './pages/auth/RecoverPassword';
import ResetPassword from './pages/auth/ResetPassword';
import VerifyEmail from './pages/auth/Verify';
import AdminVerifyUser from './pages/auth/AdminVerifyUser';
import DraftBootstrap from './pages/draft/DraftBootstrap';
import DraftWriterMode from './pages/draft/DraftWriterMode';
import ShareableChapterWriterPage from './pages/draft/ShareableChapterWriterPage';
import DraftEditorPage from './pages/draft/DraftEditorPage';
import PrivateRoute from './pages/navigation/PrivateRoute';
import Contact from './pages/Contact';
import AdminPanel from './pages/admin/AdminPanel';
import PublisherPanel from './pages/publisher/PublisherPanel';
import PublicAuthorFeed from './pages/PublicAuthorFeed';
import AuthorSubscribeWidget from './pages/AuthorSubscribeWidget';
import ShortStoryChatPage from './pages/shortStory/ShortStoryChatPage';
import ShortStoryGeneratingPage from './pages/shortStory/ShortStoryGeneratingPage';
import ScaffoldEditorPage from './pages/scaffold/ScaffoldEditorPage';
import { appNavigation } from './utils'


// Wrapper that mounts AppProvider only after auth (avoids pre-login balance fetches)
function ProtectedShell() {
  return (
    <AppProvider>
      <Outlet />
    </AppProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  //<React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />        
        <Route path={appNavigation.login} element={<Login />} />
        <Route path={appNavigation.register} element={<Register />} />
        <Route path={appNavigation.unsubscribe} element={<Unsubscribe />} />
        <Route path={appNavigation.subscribe} element={<Subscribe />} />

        <Route path={appNavigation.contact} element={<Contact />} />
        <Route path={appNavigation.recoverPassword} element={<RecoverPassword />} />             
        <Route path={appNavigation.resetPassword} element={<ResetPassword />} />   
        <Route path={appNavigation.verify} element={<VerifyEmail />} />
        <Route path={appNavigation.adminVerifyUser} element={<AdminVerifyUser />} />
        <Route path={appNavigation.onboarding} element={<DraftBootstrap />} />
        <Route path={`${appNavigation.onboarding}/:guid`} element={<DraftBootstrap />} />
        <Route path={`${appNavigation.onboarding}/:guid/writer`} element={<DraftWriterMode />} />
        <Route path="/:authorSlug/feed" element={<PublicAuthorFeed />} />
        <Route path="/:authorSlug/subscribe-widget" element={<AuthorSubscribeWidget />} />
        
        {/* Shareable chapter links (public) */}
        <Route path="/project/:projectTitle/chapter-:chapterIndex/:guid/writer" element={<ShareableChapterWriterPage />} />
        <Route path="/draft/share/:guid" element={<ShareableChapterWriterPage />} />

        {/* Protected routes */}
        <Route element={<PrivateRoute />}>
          <Route element={<ProtectedShell />}>
            {/* Home = project chooser at EXACT /home */}
            <Route path={appNavigation.home} element={<Home />} />
            <Route path={appNavigation.adminPanel} element={<AdminPanel />} />
            <Route path={appNavigation.publisherPanel} element={<PublisherPanel />} />
            <Route path="/drafts/:draftId/edit" element={<DraftEditorPage />} />
            <Route path="/scaffolds/:scaffoldId/edit" element={<ScaffoldEditorPage />} />
            <Route path={appNavigation.shortStoryChat} element={<ShortStoryChatPage />} />
            <Route path={appNavigation.shortStoryGenerating} element={<ShortStoryGeneratingPage />} />

            {/* Dashboard handles /home/library/... etc */}          
            <Route path="/project/:projectId/*" element={<Dashboard />} />

            <Route path={appNavigation.profile} element={<ProfilePage />} />
          </Route>
        </Route>

      </Routes>
    </BrowserRouter>
  // </React.StrictMode>
)
